module.exports = __webpack_public_path__ + "static/powerful-communities-f03faf62a33f1991157e8ff1ae2f995c.jpg";